import React from "react";

export function SectionHeading({ eyebrow, title, subtitle, center = false, className = "" }) {
  return (
    <div className={`${center ? "text-center mx-auto max-w-2xl" : "max-w-2xl"} ${className}`}>
      {eyebrow && (
        <span className="font-mono text-xs uppercase tracking-[0.2em] text-brand-cyan">{eyebrow}</span>
      )}
      <h2 className="font-display mt-3 text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white">
        {title}
      </h2>
      {subtitle && <p className="mt-4 text-base text-slate-400 leading-relaxed">{subtitle}</p>}
    </div>
  );
}

export function EmptyState({ message, icon: Icon }) {
  return (
    <div className="card-surface rounded-2xl py-16 px-6 text-center" data-testid="empty-state">
      {Icon && <Icon className="mx-auto h-10 w-10 text-slate-600 mb-4" />}
      <p className="text-slate-500">{message}</p>
    </div>
  );
}
